import React from 'react';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';

export const ExportToExcel = ({ apiData, fileName, dateTo, dateFrom, articleHeader }) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const processDataHandler = () => {
        const headersToExport = articleHeader.filter(h => h.key !== 'actions');

        return apiData.map(item => {
            const row = {};

            headersToExport.forEach(header => {
                let value = '';

                switch (header.key) {
                    case 'id':
                        value =
                            new Date(item?.date_joined).toISOString().split('T')[0].split('-')[0].slice(-2) +
                            new Date(item?.date_joined).toISOString().split('T')[0].split('-')[1] +
                            new Date(item?.date_joined).toISOString().split('T')[0].split('-')[2] +
                            new Date(item?.date_joined).toISOString().split('T')[1].split(':')[0] +
                            new Date(item?.date_joined).toISOString().split('T')[1].split(':')[1] +
                            item?.id;
                        break;

                    case 'user_name':
                        value = `${item?.first_name || ''} ${item?.last_name || ''}`;
                        break;

                    case 'subscription_type':
                        value = item?.subscription_type ? item?.subscription_type : '-';
                        break;

                    case 'household_parent':
                        value = item?.parent ? item?.parent?.email : '-';
                        break;

                    case 'propagation_parent':
                        value = item?.propagation_parent ? item?.propagation_parent?.email : '-';
                        break;

                    case 'noofchild':
                        value = Number(item?.number_of_childs) > 0 ? item?.number_of_childs : '-';
                        break;

                    case 'couponCode':
                        value = item?.code_used_while_signup_code || '-';
                        break;

                    case 'offerCode':
                        value = item?.propagation_code || '-';
                        break;

                    case 'house':
                        value = item?.status === "sub_user" ? "Household" : item?.status || '-';
                        break;

                    case 'Age':
                        value = item?.age_status || '-';
                        break;

                    case 'platformtype':
                        value = item?.os_name || item?.platform || '-';
                        break;

                    case 'Paymentstatus':
                        value = item?.payment_status || '-';
                        break;

                    case 'dateTime':
                        value =
                            item?.date_joined != null
                                ? `${moment.utc(item?.date_joined).local().format("MM-DD-YYYY")} ${moment.utc(item?.date_joined).local().format("HH:mm:ss")}`
                                : '-';
                        break;

                    case 'active':
                        value =
                            item?.last_active_login != null
                                ? `${moment.utc(item?.last_active_login).local().format("MM-DD-YYYY")} ${moment.utc(item?.last_active_login).local().format("HH:mm:ss")}`
                                : '-';
                        break;

                    default:
                        value = item?.[header.key] ?? '-';
                        break;
                }

                row[header.title] = value;
            });

            return row;
        });
    };

    const exportToCSV = () => {
        let name = `${fileName}${dateFrom ? "-" + moment.utc(dateFrom).local().format("MM-DD-YYYY") : ''}${dateTo ? "-" + moment.utc(dateTo).local().format("MM-DD-YYYY") : ''}`;
        const processedData = processDataHandler();
        const ws = XLSX.utils.json_to_sheet(processedData, { header: articleHeader.filter(h => h.key !== 'actions').map(h => h.title) });
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, name + fileExtension);
    };

    return (
        <FontAwesomeIcon
            size="xl"
            icon={faFileExcel}
            style={{ cursor: 'pointer' }}
            onClick={exportToCSV}
        />
    );
};
